import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { JwtHelperService} from '@auth0/angular-jwt';
import { User, AuthToken } from '../models/auth.models';
import { MenuItem } from 'src/app/layouts/sidebar/menu.model';
import { map } from 'rxjs/operators';
import { Registration } from '../models/registration';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {
    private currentUserSubject!: BehaviorSubject<User>;
    public currentUser1!: Observable<User>;

    user!: User;
    baseApiUrl: string = environment.baseUrl;
    jwtHelper = new JwtHelperService();
  
    
    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser1 = this.currentUserSubject.asObservable();
        }

    getIPAddress(): Observable<any> {
    return this.http.get<any>(environment.ipUrl);
    }
    /**
     * Returns the current user
     */
    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }
    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */

     login(loginForm:any): Observable<User>{
        return this.http.post<AuthToken>(this.baseApiUrl+'Auth/login',loginForm)
            .pipe(map(res => {
                // login successful if there's a jwt token in the response
                if (res.token) {
                    const user = this.jwtHelper.decodeToken(res.token);
                    user.token = res.token;
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                    return user;
                }
                throw new Error('Login failed: token missing in response');
            }));
        }
        
    getMenuList():Observable<MenuItem[]>{
    return this.http.get<MenuItem[]>(this.baseApiUrl+'User/menuList')
    .pipe(map(res=>{
        if (res) {
            return res;
        }
    }))
    }
    
    getPosition(): Promise<{ lng: number; lat: number }> {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject('UNSUPPORTED');
                return;
            }

            this.tryGetPosition(
                { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
            )
                .then(resolve)
                .catch((firstError) => {
                    if (firstError === 'PERMISSION_DENIED' || firstError === 'UNSUPPORTED') {
                        reject(firstError);
                        return;
                    }

                    this.tryGetPosition(
                        { enableHighAccuracy: false, timeout: 20000, maximumAge: 300000 }
                    )
                        .then(resolve)
                        .catch(reject);
                });
        });
    }

    private tryGetPosition(options: PositionOptions): Promise<{ lng: number; lat: number }> {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
                (resp) => {
                    resolve({
                        lng: resp.coords.longitude,
                        lat: resp.coords.latitude
                    });
                },
                (err) => {
                    if (err.code === err.PERMISSION_DENIED) {
                        reject('PERMISSION_DENIED');
                    } else if (err.code === err.POSITION_UNAVAILABLE) {
                        reject('POSITION_UNAVAILABLE');
                    } else if (err.code === err.TIMEOUT) {
                        reject('TIMEOUT');
                    } else {
                        reject('UNKNOWN');
                    }
                },
                options
            );
        });
    }
    
    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    // register(email: string, password: string) {
    //     return getFirebaseBackend().registerUser(email, password).then((response: any) => {
    //         const user = response;
    //         return user;
    //     });
    // }

    /**
     * Reset password
     * @param email email
     */
     resetPassword(email: string) {
        return this.http.post(this.baseApiUrl+'Auth/forgot-password?username='+email,null) 
    }

    resetPwd(data: any) {
        return this.http.post<any>(this.baseApiUrl+'Auth/reset-password',data) 
    }   

    changePassword(password: string, newpass: string) {
        return this.http.post(this.baseApiUrl + 'user/changepassword?oldPass=' + password + '&newPass=' + newpass + '&newPass1=' + newpass, null)
    }

    /**
     * Logout the user
     */
     logout() {
         // logout the user
         const user = null as unknown as User;
         // store user details and jwt token in local storage to keep user logged in between page refreshes
         localStorage.removeItem('currentUser');
         this.currentUserSubject.next(user);
         return user;
     }

    register(registration: Registration): Observable<User> {
        return this.http.post<User>(this.baseApiUrl + 'Auth/register', registration);
    }
    regverify(regVerificationToken: string): Observable<any> {
        return this.http.post<any>(this.baseApiUrl + 'Auth/regVerify?VerificationToken='+ regVerificationToken, null);
    }
    verify(regVerificationToken: string): Observable<any> {
        return this.http.post<any>(this.baseApiUrl + 'Auth/Verify?VerificationToken='+ regVerificationToken, null);
    }

}
